import React from 'react';
import moment from 'moment-jalaali';
import { Message, Content, Date, ArchiveBox } from './styles';
import messages from './Messages';
import ActionLink from 'components/ActionLink';
import Icon from 'components/Icon';
import SanitizedHTML from 'react-sanitized-html';
import { IMessageView } from 'store/messages/messagesSlice';
import { IEvent } from 'store/tasks/tasksType';

moment.loadPersian({ dialect: 'persian-modern' });

interface IMsgViewProps {
  msg: IMessageView;
  onClickOnMessage: (id: number) => void;
  onArchiveMsg: (id: number, archived: boolean) => void;
  myLastMessageSeen: number;
  selected: boolean;
}

class MsgView extends React.Component<IMsgViewProps> {
  handleClick = () => {
    const context = (this.props.msg.content as IEvent).context;
    if (context.type === 'task') {
      this.props.onClickOnMessage(context.id);
    }
  };

  handleArchive = () => {
    const { onArchiveMsg, msg } = this.props;
    onArchiveMsg(msg.id, !msg.archived);
  };

  render() {
    const { msg, myLastMessageSeen, selected } = this.props;
    const message = msg.content as IEvent;
    return (
      <Message
        unread={msg.sendTime > myLastMessageSeen + 1}
        selected={selected}
      >
        <Content onClick={this.handleClick}>
          <ActionLink color="blue" size={16}>
            <SanitizedHTML
              style={{ display: 'inline' }}
              html={message.title ? message.title : msg.content}
            />
          </ActionLink>
          <div>{message?.text ? message.text : (msg.content as string)}</div>
          <Date>{moment(msg.sendTime).fromNow()}</Date>
        </Content>
        <ArchiveBox>
          {msg.archived ? (
            <ActionLink
              color="red"
              onClick={this.handleArchive}
              title={messages.restore}
            >
              <Icon type={'upload'} />
            </ActionLink>
          ) : (
            <ActionLink
              color="green"
              onClick={this.handleArchive}
              title={messages.archive}
            >
              <Icon type={'archive'} />
            </ActionLink>
          )}
        </ArchiveBox>
      </Message>
    );
  }
}

export default MsgView;
